import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchIndustryData,
  setSelectedIndustry,
} from "../../redux/actions/industryActions";
import {
  fetchCompanyCategories,
  selectCompanyCategory,
} from "../../redux/actions/companyCategoryActions";
import {
  fetchCompanySizeData,
  selectCompanySize,
} from "../../redux/actions/companySizeActions";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";

const UpdateRecruiterProfile = () => {
  const sessionId = localStorage.getItem("sessionId");
  const userUID = localStorage.getItem("userUID");
  const [displays, setDisplays] = useState(false);
  // ...............................Industry DDL.......................................
  const [industryId, setIndustryId] = useState(null);
  const dispatch = useDispatch();
  const { industryList, selectedIndustryId } = useSelector(
    (state) => state.industry
  );
  useEffect(() => {
    dispatch(fetchIndustryData());
  }, [dispatch]);
  const handleIndustrySelect = (val) => {
    setIndustryId(val.value);
    // dispatch(setSelectedIndustry(val.value));
  };
  // ...............................Industry DDL.......................................

  // ...............................Company Category DDL.......................................

  const [companyCategoryId, setCompanyCategoryId] = useState(null);
  const { categories, selectedCompanyCategoryId } = useSelector(
    (state) => state.companyCategory
  );
  useEffect(() => {
    dispatch(fetchCompanyCategories());
  }, [dispatch]);
  const handleCompanySelect = (selectedOption) => {
    if (selectedOption) {
      setCompanyCategoryId(selectedOption.value);
      // dispatch(selectCompanyCategory(selectedOption.value));
    }
  };

  // ...............................Company Category DDL.......................................

  // ...............................Company Size DDL.......................................

  const [companySizeId, setCompanySizeId] = useState(null);
  const { companySizes, selectedCompanySizeId } = useSelector(
    (state) => state.companySize
  );
  useEffect(() => {
    dispatch(fetchCompanySizeData());
  }, [dispatch]);
  const handleCompanySizeSelect = (selectedOption) => {
    if (selectedOption) {
      setCompanySizeId(selectedOption.value);
      // dispatch(selectCompanySize(selectedOption.value));
    }
  };
  // ...............................Company Size DDL.......................................

  // ...............................City Dropdown.......................................
  const [cityId, setcityId] = useState("");
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);

  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      setcityId(selectedOption.value);
      // dispatch(selectCity(selectedOption.value));
    }
  };
  // ...............................City Dropdown.......................................

  // ...............................PROFILE Start.......................................
  const [emailValue, setEmailValue] = useState("");
  const [contactNoValue, setContactNoValue] = useState("");
  const [websiteValue, setWebsiteValue] = useState("");
  const [taglineValue, setTaglineValue] = useState("");
  const [aboutValue, setAboutValue] = useState("");
  const [descriptionValue, setDescriptionValue] = useState("");
  const [addressValue, setAddressValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageView, setProfileImageView] = useState(null);

  const handleProfileImageChange = (event) => {
    const selectedFile = event.target.files[0];
    setProfileImage(selectedFile);
    setProfileImageView(URL.createObjectURL(selectedFile));
  };

  const Comapny = async (e) => {
    e.preventDefault();
    try {
      setDisplays(true);
      if (
        emailValue &&
        contactNoValue &&
        websiteValue &&
        taglineValue &&
        aboutValue &&
        descriptionValue &&
        companyCategoryId &&
        industryId &&
        companySizeId &&
        addressValue &&
        cityId &&
        startDate &&
        profileImage !== ""
      ) {
        const formData = new FormData();
        formData.append("emailId", emailValue);
        formData.append("contactId", contactNoValue);
        formData.append("websiteId", websiteValue);
        formData.append("taglineId", taglineValue);
        formData.append("aboutId", aboutValue);
        formData.append("descriptionId", descriptionValue);
        formData.append("companyCategoryId", companyCategoryId);
        formData.append("industryId", industryId);
        formData.append("companySizeId", companySizeId);
        formData.append("addressId", addressValue);
        formData.append("CityId", cityId);
        formData.append(
          "Dob",
          startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
        );
        formData.append("ProfileImage", profileImage);
        formData.append("sessionId", sessionId);
        const res = await axios.post(
          "/Account/UpdateCompanyProfile",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        toast.success(res.data.message);
        setCityValue("");
        setStartDate("");
        setProfileImage("");
        setAboutValue("");
        setAddressValue("");
        setCompanyCategoryId("");
        setCompanySizeId("");
        setContactNoValue("");
        setDescriptionValue("");
        setDisplays("");
        setEmailValue("");
        setIndustryId("");
        setWebsiteValue("");
        setTaglineValue("");
        setDisplays(false);
      } else {
        toast.error("please enter required fields!");
        // { position: "top-center" }
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // ...............................Get PROFILE Start.......................................
  const [profileData, setProfileData] = useState("");
  const GetProfile = async () => {
    try {
      const res = await axios.get(
        `/Company/GetProfile?UID=${userUID}&CompType=Recruiter`
      );
      setProfileData(res.data.responseData);
      console.log("=====>", res.data.responseData);
      const userData = res.data.responseData;
      localStorage.setItem("name", userData.name);
      localStorage.setItem("startedDate", userData.startedDate);
      localStorage.setItem("compType", userData.compType);
      localStorage.setItem("cityName", userData.cityName);
      localStorage.setItem("email", userData.email);
      localStorage.setItem("profilPic", userData.logoImage);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    GetProfile();
  }, []);
  console.log("res", profileData);

  useEffect(() => {
    if (profileData) {
      setEmailValue(profileData?.email);
      setContactNoValue(profileData?.contactNo);
      setWebsiteValue(profileData?.website);
      setTaglineValue(profileData?.tagline);
      setAboutValue(profileData?.about);
      setDescriptionValue(profileData?.description);
      setCompanyCategoryId("");
      setIndustryId("");
      setCompanySizeId("");
      setAddressValue("");
      setCityValue(profileData?.cityId);
      setStartDate(profileData?.startedDate);
      setProfileImageView(profileData?.logoImage);
      dispatch(setSelectedIndustry(profileData?.industryId));
      dispatch(selectCompanyCategory(profileData?.companyCategoryId));
      dispatch(selectCompanySize(profileData?.companySizeId));
      dispatch(selectCity(profileData?.cityId));
    }
  }, [profileData]);

  // ...............................Get PROFILE End.......................................
  return (
    <>
      <h6>Profile Setting</h6>
      <div className="profile-setting-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="companymail">Recruiter Email</label>
            <input
              type="text"
              id="companymail"
              className="form-control Dark-Input-from-group"
              required
              onChange={(e) => setEmailValue(e.target.value)}
              value={emailValue}
              invalid={displays && emailValue === ""}
            />
            {displays && !emailValue ? (
              <span className="error_msg_lbl text-red">Enter Email </span>
            ) : null}
          </div>

          <div className="form-group">
            <label htmlFor="contact">Contact No</label>
            <input
              type="text"
              id="contact"
              className="form-control Dark-Input-from-group"
              required
              onChange={(e) => setContactNoValue(e.target.value)}
              value={contactNoValue}
              invalid={displays && contactNoValue === ""}
            />
            {displays && !contactNoValue ? (
              <span className="error_msg_lbl text-red">Enter No </span>
            ) : null}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="CompanyCategoryId">Website Name </label>
            <input
              type="text"
              id="contact"
              className="form-control Dark-Input-from-group"
              required
              onChange={(e) => setWebsiteValue(e.target.value)}
              value={websiteValue}
              invalid={displays && websiteValue === ""}
            />
            {displays && !websiteValue ? (
              <span className="error_msg_lbl text-red">Enter Website </span>
            ) : null}
          </div>
          <div className="form-group">
            <label htmlFor="IndustryId">Tagline </label>
            <input
              type="text"
              id="contact"
              className="form-control Dark-Input-from-group"
              required
              onChange={(e) => setTaglineValue(e.target.value)}
              value={taglineValue}
              invalid={displays && taglineValue === ""}
            />
            {displays && !taglineValue ? (
              <span className="error_msg_lbl text-red">Enter Tagline </span>
            ) : null}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="CompanySizeId">Company Size </label>
            <ReactSelect
              options={companySizes}
              onChange={handleCompanySizeSelect}
              value={
                companySizes.find((option) => option.value === companySizeId) ||
                null
              }
              styles={customStyles}
              classNamePrefix="react-select"
              className="form-control"
            />
            {displays && !companySizeId ? (
              <span className="error_msg_lbl text-red">
                Select Company Size
              </span>
            ) : null}
          </div>
          <div className="form-group">
            <label htmlFor="city">City</label>
            <ReactSelect
              options={cityList}
              onChange={handleCitySelect}
              value={cityList.find((option) => option.value === cityId) || null}
              styles={customStyles}
              classNamePrefix="react-select"
              className="form-control"
            />
            {displays && !cityValue ? (
              <span className="error_msg_lbl text-red">Select City</span>
            ) : null}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="website">Company Category</label>
            <ReactSelect
              options={categories}
              onChange={handleCompanySelect}
              // onChange={(e) => handleCompanySelect}
              value={
                categories.find(
                  (option) => option.value === companyCategoryId
                ) || null
              }
              styles={customStyles}
              classNamePrefix="react-select"
              className="form-control"
            />
            {displays && !companyCategoryId ? (
              <span className="error_msg_lbl text-red">
                Select Company Category
              </span>
            ) : null}
          </div>

          <div className="form-group">
            <label htmlFor="tagline">Industry</label>

            <ReactSelect
              options={industryList}
              onChange={handleIndustrySelect}
              styles={customStyles}
              classNamePrefix="react-select"
              className="form-control"
            />

            {displays && !industryId ? (
              <span className="error_msg_lbl text-red">Select Industry</span>
            ) : null}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="IncorpDate">Incorporate Date</label>
            <Flatpickr
              id="dob"
              className="form-control Dark-Input-from-group"
              required
              onChange={(date) => setStartDate(date[0])}
              value={startDate}
              invalid={displays && startDate === ""}
            />
            {displays && !startDate ? (
              <span className="error_msg_lbl text-red">Enter Date </span>
            ) : null}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Logo Image</label>
            {/* <div className="avatar-upload-info"> */}
            <input
              type="file"
              className="form-control Dark-Input-from-group"
              required
              // onChange={(e) => setProfileImage(e.target.value)}
              onChange={(e) => {
                handleProfileImageChange(e);
              }}
              // value={profileImage}
              invalid={displays && profileImage === ""}
            />
            {displays && !profileImage ? (
              <span className="error_msg_lbl text-red">Upload Image </span>
            ) : null}
            {/* </div> */}
          </div>
          <div className="form-group">
            <img src={profileImageView} width={200} height={200} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="About">About</label>
          <textarea
            className="form-control Dark-Input-from-group"
            required
            onChange={(e) => setAboutValue(e.target.value)}
            value={aboutValue}
            invalid={displays && aboutValue === ""}
          ></textarea>
          {displays && !aboutValue ? (
            <span className="error_msg_lbl text-red">Write About </span>
          ) : null}
        </div>
        <div className="form-group">
          <label htmlFor="Description">Description</label>
          <textarea
            className="form-control Dark-Input-from-group"
            required
            onChange={(e) => setDescriptionValue(e.target.value)}
            value={descriptionValue}
            invalid={displays && descriptionValue === ""}
          ></textarea>
          {displays && !descriptionValue ? (
            <span className="error_msg_lbl text-red">Enter Description </span>
          ) : null}
        </div>
        <div className="form-group">
          <label htmlFor="Address">Address</label>
          <textarea
            className="form-control Dark-Input-from-group"
            required
            onChange={(e) => setAddressValue(e.target.value)}
            value={addressValue}
            invalid={displays && addressValue === ""}
          ></textarea>
          {displays && !addressValue ? (
            <span className="error_msg_lbl text-red">Enter Address </span>
          ) : null}
        </div>

        <button className="btn btn-primary" onClick={(e) => Comapny(e)}>
          Update
        </button>
      </div>
    </>
  );
};

export default UpdateRecruiterProfile;
